export const form = async (err) => {
  if (err) {
    console.error(err);
  }

  function wpforms() {
    // get form elements
    const formContainers = document.querySelectorAll('.wpforms-field-checkbox');
    // loop through each form container
    formContainers.forEach((container) => {
      // loop through each requiredList element
      const requiredListItems = container.querySelectorAll(
        '.wpforms-field-required'
      );

      // restrict checkbox selection to the number specified in the data attribute data-choice-limit

      requiredListItems.forEach((item) => {
        const choiceLimit = parseInt(item.dataset.choiceLimit, 10);
        let checkedCount = 0;
        console.log(`container`, container.dataset);
        console.log(`choiceLimit`, choiceLimit);
        // get children checkboxes
        const checkboxes = item.querySelectorAll('input[type="checkbox"]');
        // add event listener to each checkbox
        checkboxes.forEach((checkbox) => {
          checkbox.addEventListener('change', () => {
            // count checked checkboxes
            checkedCount = Array.from(checkboxes).filter(
              (cb) => cb.checked
            ).length;

            // if checked count exceeds choice limit, uncheck the last checked checkbox
            if (checkedCount > choiceLimit) {
              checkbox.checked = false;
            }
          });
        });
      });

      // stop selection if the limit is reached
      requiredListItems.forEach((item) => {
        const checkbox = item.querySelector('input[type="checkbox"]');
      });
    });
  }

  if (document.getElementsByClassName('wpforms-container').length) {
    wpforms();
  }
};

import.meta.webpackHot?.accept(form);
